import { useEffect } from 'react'

/**
 * Custom hook to handle modal close behavior
 * - Closes modal when ESC key is pressed
 * - Returns handler for closing when clicking outside (backdrop)
 */
export function useModalClose(onClose: () => void) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [onClose])

  // Handler for clicking the backdrop (outside the modal)
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return { handleBackdropClick }
}












